module.exports = __webpack_public_path__ + "img/weixiuliucheng.e100af19.png";